import $ from 'jquery';
import { hideAllMenus } from '~core/hideAllMenus';
import { hideSidebars } from '~core';

export const resetEditorState = () => {
  hideAllMenus();
  hideSidebars();
  $('#editor-menu-default').show();
  $('#editor-menu-object').hide();

  $('[data-navbar-submenu="text-opacity"]')
    .removeClass('active')
    .css('top', -500);
};
